<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-card-title>
        <span>Đổi mật khẩu</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="errors_exist">
            <v-col cols="12">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.current_password"
                :type="show_currp ? 'text' : 'password'"
                :append-icon="show_currp ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show_currp = !show_currp"
                label="Mật khẩu cũ"
                class="require"
                autocomplete="off"
                hide-details
                autofocus
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.password"
                :type="show_np ? 'text' : 'password'"
                :append-icon="show_np ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show_np = !show_np"
                label="Mật khẩu mới"
                class="require"
                autocomplete="off"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.password_confirmation"
                :type="show_rnp ? 'text' : 'password'"
                :append-icon="show_rnp ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show_rnp = !show_rnp"
                label="Nhập lại Mật khẩu mới"
                class="require"
                autocomplete="off"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="saveChangePassword(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        show_currp: false,
        show_np: false,
        show_rnp: false,
        dialog: false,
        item: {
          current_password: '',
          password: '',
          password_confirmation: ''
        },
        errors_exist: false,
        errors: []
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      saveChangePassword(item){
        const app=this;
        axios.post('api/v1/auth/change-password', item)
          .then((response) => {
            app.$emit('confirmed', response.data);
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>